import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "../../../../../shared/const/localstorage";
import {StudentsListingResponse} from "../../../types/create-test/student-listing/studentsListingSchema";
import {setStudentsListing} from "../../../slice/create-test/students-listing/studentListingSlice";


export const studentListing = createAsyncThunk(
    "createTest/fetchStudents",
    async (_, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);
            const response = await axios.get<StudentsListingResponse>("/api/tests/students-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (!response.data) {
                throw new Error("Response data is empty");
            }

            thunkAPI.dispatch(setStudentsListing(response.data.data))
            return response.data;
        } catch (error) {
            // @ts-ignore
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);